import { Grid } from './grid';
/**
 * The abstract class Node describes 
 * the logical representation of a node in a graph or a tree
 */
export abstract class Node {

    //Default color of the node
    protected defaultColor: string = 'yellow';

    //Coordinate of the node
    protected rowIndex: number;
    protected colIndex: number;
    //current color of the node
    protected color: string;
    //current name of the node
    protected name: string;
    //imagepath (old idea. Never implemented it... For the future?)
    protected imagePath: string;
    //Id of the node
    protected id: number;
    //If node should be visible or not. Mostly used to make the node invisble
    //when performing drag and node.
    protected visible = true;

    //Globad ID to distribute different ID's among nodes.
    static globalId = 1;

    //Reference to all neighboring nodes
    protected neighbors: Node[] = [];

    /**
     *
     * @param rowIndex row index of your node
     * @param colIndex column index of your node
     * @param id pass null for newly created nodes. pass an id if node is loaded from JSON
     */
    constructor(rowIndex: number, colIndex: number, id: number) {
        this.color = this.defaultColor;
        this.rowIndex = rowIndex;
        this.colIndex = colIndex;

        /*May check this line in case of an error*/
      if (id == null) {
            this.id = Node.globalId;
            Node.globalId++;
        } else {
            /*console.log('Node at [' + rowIndex + ',' + colIndex + '], id: ' + id);*/
            this.id = id;

            if (this.id >= Node.globalId) {
              Node.globalId = this.id + 1;
            }
        }
    }

    static updateGlobalId(id: number) {
      if (id > Node.globalId) {
        Node.globalId = id + 1;
      }
    }

    abstract inParameter(e: MouseEvent, grid : Grid):boolean;
    abstract clone(): Node;

    getId(): number {
        return this.id;
    }

    getName(): string {
        return this.name;
    }

    setVisibility(visible: boolean) {
        this.visible = visible;
    }
    /**
     * Sets the color of the node
     */
    setColor(color: string) {
        this.color = color;
    }
    /**
    * Set the color back to default
    */
    setDefaultColor() {
        this.color = this.defaultColor;
    }
    /**
     * Sets the path to the image the node should display
     */
    setImage(path: string) {
        this.imagePath = path;
    }

    setName(name: string) {
        this.name = name;
    }

    /**
     *  Adds neighbor to its neigbors list
     */
    addNeighbor(neighbor: Node) {
        if (neighbor == null) {
            return;
        }

        const index: number = this.neighbors.indexOf(neighbor);
        if (!this.isNeighbor(neighbor)) {
            this.neighbors.push(neighbor);
        }
    }

    /**
     *  Remove neighbor from its neighbors list.
     */
    removeNeighbor(neighbor: Node) {
        if (neighbor == null) {
            return;
        }

        const index: number = this.neighbors.indexOf(neighbor);
        if (this.isNeighbor(neighbor)) {
            this.neighbors.splice(index, 1);
        }
    }

    public getNeighbors(): Node[] {
        return this.neighbors;
    }

    isNeighbor(neighbor: Node): boolean {
        const index: number = this.neighbors.indexOf(neighbor);
        if (index == -1) {
            return false;
        }
        return true;
    }





    /**
     * 
     * @param ctx reference to the context of the canvas
     * @param grid reference to the grid
     * 
     * This method is beeing called in the graph class
     */
    abstract draw(ctx: CanvasRenderingContext2D, grid: Grid);

    getRowIndex(): number {
        return this.rowIndex;
    }

    getColIndex(): number {
        return this.colIndex;
    }

    /*Drag and Drop purpose*/
    changeCoordinates(newRow: number, newCol: number) {
        this.colIndex = newCol;
        this.rowIndex = newRow;
    }

    drawShadow(ctx: CanvasRenderingContext2D, x: number, y: number, grid: Grid) {
        this.shadowRawX = x;
        this.shadowRawY = y;

        ctx.globalAlpha = 0.4;
        ctx.beginPath();
        ctx.fillStyle = this.color;
        ctx.ellipse(x, y, grid.getWidthRadius(), grid.getHeightRadius(), 0, 0, 2 * Math.PI);

        ctx.fill();
        ctx.strokeStyle = 'black';

        ctx.stroke();

      ctx.closePath();

        ctx.fillStyle = 'black';
        ctx.font = 'bold 10pt Courier';
        ctx.textAlign = 'center';
        ctx.fillText(this.name, x, y, Math.max(2 * grid.getWidthCell() / 3, 2 * grid.getHeightCell() / 3));
        ctx.globalAlpha = 1;
    }

    //Used for drawing a shadow version of the node when using drap&drop
    private shadowRawX: number;
    private shadowRawY: number;

    getShadowRawX(): number {
        return this.shadowRawX;
    }

    getShadowRawY(): number {
        return this.shadowRawY;
    }

    isVisible(): boolean {
        return this.visible;
    }

    public toString = (): string => {

        return 'Node: ' + this.getName();
    }
}
